import { Box } from "@mui/material";
import styled from "styled-components";
import { SubSectionContainerText } from "components/SubSection/SubSection.styled";

export const CareersSelectionProcessCardContainer = styled(Box)`
  display: flex;
  justify-content: center;
  padding-bottom: 40px;
  @media (max-width: 768px) {
    &:last-of-type {
      padding-bottom: 57px;
    }
    &:first-of-type {
      padding-top: 20px;
    }
  }
`;

export const CareersSelectionProcessCardParagraph = styled(Box)`
  background-color: ${(props) => props?.theme.colors[props?.$color ?? "white"]};
  border-radius: 16px;
  width: 100%;
  max-width: 712px;
  min-width: 280px;

  display: flex;
  grid-row-gap: 24px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  padding: 24px 29px;

  text-decoration: none;
`;

export const CareersSelectionProcessCardParagraphHeader = styled(Box)`
  display: block;
  color: ${(props) => props?.theme.colors?.subTitleColor};
  font-stretch: ultra-expanded;
  font-weight: 800;

  font-size: 17px;
  line-height: 30.87px;
`;

export const CareersSelectionProcessCardParagraphText = styled(Box)`
  padding: 0 8px;
  & ${SubSectionContainerText} {
    width: 100%;
    margin: 0;
    max-width: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${(props) => props?.theme.colors.thirdTextColor};
  }
`;

export const Bold = styled.span`
  font-weight: 700;
  font-stretch: expanded;
`;

export const CareersSelectionProcessImage = styled.div`
  background-image: url(${(props) => props?.$src});
  background-size: cover;
  background-position: center;
  border-radius: 50%;
  width: ${(props) => props?.$height};
  height: ${(props) => props?.$height};

  color: ${(props) => props?.theme.colors.dark};
  font-family: "Mona-Sans";
  font-weight: 700;
  font-size: 41.69px;
  line-height: 100%;
  letter-spacing: -1.16px;
  vertical-align: middle;

  display: flex;
  align-items: center;
  justify-content: center;
`;
